import { render } from "./CheckoutSummary.vue?vue&type=template&id=5baade90&lang=pug"
import script from "./CheckoutSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutSummary.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__